// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"448a2c5e","389":"f5890d3c","453":"f57bc842","732":"aae1c413","977":"518663e3"}[chunkId] + ".chunk.js";
};